import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmArrowRight } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { Cta } from '../../components/Cta/cta.js';

const Action = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const {
    onAction
  } = useLlm(state => state.actions);
  const {
    open
  } = useLlmView(state => state.actions);
  const dismissable = useLlmView(state => state.dismissable);
  const onAction_ = event => __awaiter(void 0, void 0, void 0, function* () {
    // console.log('Action.onAction', item.id);
    const shouldClose = yield onAction(item);
    if (dismissable && shouldClose !== false) {
      open();
    }
  });
  const classNames = getClassNames('llm__action', {
    [`llm__action--${item.type}`]: !!item.type
  });
  return jsx(Cta, {
    type: "button",
    className: classNames,
    label: item.title || label('llm.tellMeMore'),
    icon: jsx(IconLlmArrowRight, {}),
    onClick: onAction_
  });
};

export { Action };
//# sourceMappingURL=action.js.map
